export const useFooterLinks = () => {
  const {
    data: footerLinks,
    pending,
    error,
  } = useFetch("/api/footerLinks", {
    key: "footerLinks",
  });

  return { footerLinks, pending, error };
};
